module.exports = __webpack_public_path__ + "media/images/redesign-images/graduate-program/grad-04-19e1b46f44a58f3d644fff9cc25493d2.webp";